// extracted by mini-css-extract-plugin
export var card = "_kb-5";
export var cardSelected = "_kb-4";
export var image = "_kb-3";
export var modal = "_kb-0";
export var modalContent = "_kb-1";
export var table = "_kb-2";